import { Injectable } from "@angular/core";
import { Observable, map, catchError, of, throwError } from "rxjs";
import { WebApiService } from "./web-api.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private apiUrl = "User";

  constructor(private http: WebApiService) {}

  getUsers(): Observable<any[]> {
    return this.http.get(this.apiUrl);
  }

  getUser(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getAdminUser(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/GetAdminUser/${id}`);
  }

  createUser(item: any): Observable<any> {
    return this.http.post(this.apiUrl, item);
  }

  updateUser(item: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${item.id}`, item);
  }

  updateUserWithBody(item: any): Observable<any> {
    return this.http.put(this.apiUrl, item);
  }

  deleteUser(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  getUserByUsername(username: string): Observable<any | null> {
    const term = (username || "").trim();
    if (!term) {
      return of(null);
    }

    return this.http
      .get(`${this.apiUrl}/ByTerms/${encodeURIComponent(term)}`)
      .pipe(
        map((users: any) => {
          if (!Array.isArray(users)) {
            return null;
          }
          const lower = term.toLowerCase();
          return (
            users.find(
              (u) => u?.username && u.username.toLowerCase() === lower
            ) || null
          );
        }),
        catchError(() => of(null))
      );
  }

  searchUsers(term: string): Observable<any[]> {
    const t = (term || "").trim();
    if (!t) {
      return of([]);
    }
    return this.http
      .get(`${this.apiUrl}/ByTerms/${encodeURIComponent(t)}`)
      .pipe(
        map((users: any) => (Array.isArray(users) ? users : [])),
        catchError(() => of([])),
      );
  }

  verifyUser(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${id}/verify`, {});
  }

  denyUser(id: number, reason: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${id}/deny`, { reason });
  }

  deleteAccount(id: number, token?: string): Observable<any> {
    const options: any = {
      responseType: "text",
    };
    if (token) {
      options.headers = { Authorization: `Bearer ${token}` };
    }
    return this.http.delete(`${this.apiUrl}/${id}`, options).pipe(
      map((response: any) => {
        return response || "Success";
      }),
      catchError((error: any) => {
        if (
          error.status === 200 ||
          (error.error &&
            error.error.text &&
            error.error.text.includes("deleted successfully"))
        ) {
          return of("User deleted successfully");
        }
        return throwError(() => error);
      })
    );
  }
}
